module.exports = __webpack_public_path__ + "stripe-0dfeab0e0f464be4b28f.svg";